<template>
    <div class="info_cell fr" @click="go(`infodetail?id=${info.information_id}`)">
        <div class="left mr20 fc jsb">
            <div>
                <p class="mb10">{{info.information_title}}</p>
                <p class="mb10 fz14 grey">{{info.information_desc}}</p>
            </div>
            <p class="fz14 grey">{{info.create_time}}</p>
        </div>
        <img :src="info.information_imgs.split(',')[0]" alt />
    </div>
</template>

<script>
export default {
    props: {
        info: Object
    },
    data() {
        return {};
    },
    computed: {},
    created() {},
    mounted() {},
    watch: {},
    methods: {},
    components: {}
};
</script>

<style scoped lang="scss">
.info_cell {
    height: 120px;
    padding: 10px 0;
    border-bottom: 1px solid #e5e5e5;
    .left {
        width: calc(100% - 120px);
        height: 100%;
    }
    img {
        width: 100px;
        height: 100px;
    }
}
</style>



// WEBPACK FOOTER //
// src/page/homePage/homeInfo/InfoCell.vue